import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowLeftIcon, ArrowRightIcon } from "lucide-react";
import { galleryImages } from "../data/product";
export function BundleGallery() {
  const [index, setIndex] = useState(0);
  const total = galleryImages.length;
  const go = (dir: number) => setIndex(i => (i + dir + total) % total);
  return <div data-id="element-20" data-mp="trgg6z17tslr">
      <div className="relative aspect-[4/3] overflow-hidden rounded-[22px] bg-chip" data-id="element-21" data-mp="tr6q7bg67lg2">
        <AnimatePresence initial={false} data-id="element-22" data-mp="osveev6bf0v7">
          <motion.img key={index} src={galleryImages[index].src} alt={galleryImages[index].alt} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.2,
          ease: "easeOut"
        }} className="absolute inset-0 h-full w-full object-cover" data-id="element-23" data-mp="otx15wwp1bsr" />
        </AnimatePresence>
      </div>
      <div className="mt-4 flex items-center gap-2 sm:gap-3" data-id="element-24" data-mp="2a5ortykg6him">
        <button type="button" onClick={() => go(-1)} aria-label="Immagine precedente" className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-line bg-white text-wine transition-colors duration-150 ease-out hover:bg-chip" data-id="element-25" data-mp="nz2l8urdbcza">
          <ArrowLeftIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-26" data-mp="11yaqo5e4jhbx" />
        </button>
        <div className="flex min-w-0 flex-1 gap-2 overflow-x-auto py-1" data-id="element-27" data-mp="581q6htdc1l0">
          {galleryImages.map((img, i) => <button key={img.src} type="button" onClick={() => setIndex(i)} aria-label={`Mostra immagine ${i + 1}`} aria-current={i === index} className={`relative h-14 w-[72px] shrink-0 overflow-hidden rounded-xl border-2 transition-colors duration-150 ease-out sm:h-16 sm:w-20 ${i === index ? "border-wine" : "border-transparent opacity-80 hover:opacity-100"}`} data-id="element-28" data-mp="98lovptlbd99" data-mpi={i}>
              <img src={img.src} alt="" className="h-full w-full object-cover" data-id="element-29" data-mp="tszvvt5arpr9" />
            </button>)}
        </div>
        <button type="button" onClick={() => go(1)} aria-label="Immagine successiva" className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-line bg-white text-wine transition-colors duration-150 ease-out hover:bg-chip" data-id="element-30" data-mp="ou6s4sftbd4a">
          <ArrowRightIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-31" data-mp="avqba8o8k68f" />
        </button>
      </div>
    </div>;
}